import styled from 'styled-components';
import { Btn } from 'components';

export const LoginContainer = styled.div`
`;

export const BtnSignUpStyled = styled(Btn)`
    text-decoration-line: underline;
`;

export const BtnWrapper = styled.div`
    width: 242;
`;